import React from 'react';
import './TestimonialsPage.css';

// An array of objects to hold all your testimonial content
const testimonials = [
  {
    quote:
      'We could not have had a better performer! The crowd, of mixed ages, loved him and were able to relax to his soulful music while experiencing different boutique wines. It was a great welcome for guests entering the event.',
    author: 'Jacqui',
    organization: 'Boutique Wine Festival',
  },
  {
    quote:
      'We were delighted with the music that you played, which was perfect for our event. We have received a great many favourable comments from visitors, and it was clear that your music touched people of all generations... Overall we thought your presentation was slick, professional and above all, you play great music!',
    author: 'Kevin Sharp',
    organization: 'Mocha Events Ltd (The Chocolate and Coffee Show)',
  },
  {
    quote:
      'As pre-fight entertainment for 650 VIP corporates, Sax in the City played a variety of smooth tunes that created a warm and welcoming atmosphere that was well received by our guests. Even Reid is a talented sax player who really knows how to capture an audience.',
    author: 'Chante Betham-Spencer',
    organization: 'Monty Betham Steps for Life Foundation',
  },
  {
    quote:
      'Quite simply, the entertainment provided by Evan has been outstanding. He is the consummate professional in all ways and never fails to capture an attentive and appreciative crowd. He also has a wonderful way with the audience. We definitely recommend him.',
    author: 'Claire Annan',
    organization: 'Morton Estate Wines Ltd',
  },
  {
    quote:
      'He delighted us and our guests with his smooth instrumentals and classic jazz standards, creating a relaxing and pleasant atmosphere which helped make our day unforgettable. His performance was precisely what we had hoped for, professional and classy.',
    author: 'Dave & Jessica Pryor',
    organization: '', // No organization, so we leave it empty
  },
];


const starshipVideoId = 'lmYeOYNP34U';

function TestimonialsPage() {
  return (
    <div className={'testimonials-page'}>
      <span className={'testimonials-eyebrow'}>What Clients Say</span>
      <h2>Testimonials</h2>
      <div className={'testimonials-heading-rule'}></div>
      <div className={'testimonials-layout'}>
        <div className={'testimonials-list'}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={'testimonial-card'}>
              <blockquote className={'testimonial-quote'}>
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <cite className={'testimonial-author'}>
                <span className={'author-name'}>{testimonial.author}</span>
                {testimonial.organization && (
                  <span className={'author-org'}>{testimonial.organization}</span>
                )}
              </cite>
            </div>
          ))}
        </div>
        <div className={'testimonials-sidebar'}>
          <div className={'video-container'}>
            <iframe
              src={`https://www.youtube.com/embed/${starshipVideoId}`}
              title={'Raising Funds for Starship @ Catalina Bay Farmers Market'}
              frameBorder={'0'}
              allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
              allowFullScreen
            ></iframe>
          </div>
          <p className={'video-caption'}>Raising Funds for Starship @ Catalina Bay Farmers Market</p>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsPage;